import React from 'react';
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import {QuizType} from "../../../types/QuizType";

// Types ----

type QuizTypeContextMenuProps = {
  quizType: QuizType
  onDeleteQuizType: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function QuizTypeContextMenu({quizType, onDeleteQuizType, editDisabled, deleteDisabled, position = 'right'}: QuizTypeContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function editQuizType() {
    void navigate(`/quiz-types/${quizType.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {/* Add quiz type permissions */}
      {auth.can('exhibit-types:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editQuizType} disabled={!!editDisabled}/>
      }

      {/* Add quiz type permissions */}
      {auth.can('exhibit-types:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteQuizType} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default QuizTypeContextMenu;